import React from 'react';
import configuration from './config.js';
 
var Avatar ;
 
	Avatar = () => (
		<div>
	        <img src={configuration.urlDocuments + 'users/' + JSON.parse(localStorage.getItem("user")).avatar }  
	        	height='30px' alt="" /> &nbsp;
		</div>
	);

export default  Avatar ;
